<template>
  <div class="sa-list-component">
    <div class="sa-list-component-header">
      <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
        <b-col lg="3">
          <p>{{ this.$i18n.t("global.lblTotalRecords") }}: {{ rows }}</p>
        </b-col>
        <b-col lg="9">
          <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
        </b-col>
      </b-row>
    </div>
    <div class="sa-list-component-body">
      <div class="b-table-sticky-header">
        <b-table sticky-header ref="table" stacked="lg" striped hover :items="appuntamenti" :fields="fields" :current-page="currentPage" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
          <template #cell(index)="row">
            {{ (currentPage - 1) * perPage + (row.index + 1) }}
          </template>
          <template #cell(actions)="{ item }">
            <!-- {{ item }} -->
            <b-container class="bv-example-row">
              <!-- <b-button size="sm" v-b-tooltip.hover title="Visualizza Dettaglio" variant="outline-secondary">
                                <i class="bi bi-eye"></i>
                            </b-button>
                            <b-button size="sm" v-b-tooltip.hover title="Modifica" variant="outline-success">
                                <font-awesome-icon icon="edit"> </font-awesome-icon>
                            </b-button> -->
              <b-button size="sm" v-b-tooltip.hover title="Presa in carico" variant="outline-info" @click="onClickAccetta(item)">
                <i class="fas fa-link"></i>
              </b-button>
            </b-container>
          </template>
        </b-table>
      </div>
      <agenda-appuntamento-accettazione-box-modal-component ref="cmpAgendaAppuntamentoAccettazioneBoxModal"></agenda-appuntamento-accettazione-box-modal-component>
    </div>
    <div class="sa-list-component-footer">
      <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
        <b-col lg="3">
          <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
        </b-col>
        <b-col lg="9">
          <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import UtilityMixin from "../../utility/UtilityMixin";
import moment from "moment";
import AgendaAppuntamentoAccettazioneBoxModalComponent from "./AgendaAppuntamentoAccettazioneBoxModalComponent.vue";
export default {
  components: { AgendaAppuntamentoAccettazioneBoxModalComponent },
  props: {
    riferimento: {
      type: String,
      default: () => {
        return moment(new Date()).format("DD-MM-YYYY");
      },
    },
  },
  mixins: [UtilityMixin],
  data() {
    return {
      pathResourceAgendaAppuntamenti: "/agendaappuntamenti",
      idAgenda: null,
      appuntamenti: [],
      rows: 0,
      perPage: 10,
      currentPage: 1,
      filtro: {},
      items: [],
      listKey: 0,
      fields: [
        {
          label: "",
          key: "index",
          sortable: false,
          thStyle: "width: 2rem",
        },
        {
          label: "Appuntamento Identificativo",
          key: "identificativoAppuntamento",
          sortable: false,
          thStyle: "width: 2rem",
        },
        {
          label: "Ora Inizio",
          key: "dataOraInizio",
          sortable: false,
          thStyle: "width: 2rem",
          formatter: (value) => {
            return moment(new Date(value)).format("HH:mm");
          },
        },
        {
          label: "Ora Fine",
          key: "dataOraFine",
          sortable: false,
          thStyle: "width: 2rem",
          formatter: (value) => {
            return moment(new Date(value)).format("HH:mm");
          },
        },
        {
          label: "Note",
          key: "note",
          sortable: false,
          thStyle: "width: 2rem",
        },
        {
          label: "",
          class: "sa-table-column-action-double",
          key: "actions",
        },
      ],
    };
  },
  mounted() {
    this.idAgenda = this.$route.params.id;
  },
  methods: {
    loadData(dataSelezionata) {
      let dataRiferimento = new Date(dataSelezionata);
      UtilityMixin.methods.loadDataResources(this.pathResourceAgendaAppuntamenti, { periodo: "G", idAgenda: this.idAgenda, dataRiferimento: moment(dataRiferimento).format("YYYY-MM-DD") }, this.loadDataSuccess, this.loadDataError);
    },
    loadDataSuccess(response) {
      this.appuntamenti = response.data.data;
      this.rows = response.data.data.length;
    },
    loadDataError(error) {
      console.log(error);
    },
    getDataFormattata(data) {
      return moment(data).format("HH:mm");
    },
    onClickAccetta(item) {
      let me = this;
      me.$refs.cmpAgendaAppuntamentoAccettazioneBoxModal.init(item);
    },
  },
};
</script>

<style scoped></style>
